import { callApi } from "@/api/callApi";
import { API_ENDPOINT } from "@/api/constant";
import type { Application, ApplicationByIdResponse, ApplicationResponse } from "@/interface/applications.interface";

export const ApplicationService = {
  async getAllApplications(): Promise<ApplicationResponse> {
    const API = `${API_ENDPOINT.clients}`;
    return callApi<ApplicationResponse>(API, { method: "GET" });
  },

  async createApplication(payload: Application): Promise<ApplicationResponse> {
    const API = `${API_ENDPOINT.clients}`;
    return callApi<ApplicationResponse>(API, { method: "POST", data: payload });
  },

  async updateApplication(id: string, payload: Application): Promise<ApplicationResponse> {
    const API = `${API_ENDPOINT.clients}/${id}`;
    return callApi<ApplicationResponse>(API, { method: "PUT", data: payload });
  },

  async deleteApplication(id: string): Promise<ApplicationResponse> {
    const API = `${API_ENDPOINT.clients}/${id}`;
    return callApi<ApplicationResponse>(API, { method: "DELETE" });
  },

  async getApplicationById(id: string): Promise<ApplicationByIdResponse> {
    const API = `${API_ENDPOINT.clients}/${id}`;
    return callApi<ApplicationByIdResponse>(API, { method: "GET" });
  },
};
